export default __webpack_public_path__ + "static/media/play.22b6a51a.png";